<template>
  <div class="box">
    <H5Header />
    <div class="title-name"></div>
    <div class="card-list" v-for="index in list" :key="index">
      <div class="card">
      <div class="card_title"></div>
      <div class="card_desc"></div>
      <div class="card_main"></div>
    </div>
    </div>
  </div>
</template>

<script>
import H5Header from '../header/index.vue'
export default {
name:'CouponCenterSkeleton',
  components: {
    H5Header,
  },
  data(){
    return {
      list:4
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  background: #fafafa;
  position:fixed ;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  .title-name {
    width: 370px;
    height: 32px;
    opacity: 0.08;
    background: #000000;
    border-radius: 21px;
    margin: 53px 0 32px 32px;
  }
  .card-list{
margin: 0 32px 24px;
.card {
height: 453px;
border-radius: 40px;
background: #e6e7e7;
padding-top: 25px ;
box-sizing: border-box;
display: flex;
flex-direction: column;
overflow: hidden;

.card_title {
  width: 370px;
height: 32px;
border-radius: 21px;
margin-bottom:20px;
margin-left: 34px;
background: #dcdcdc;
}
.card_desc {
width: 258px;
height: 32px;
border-radius: 21px;
margin-bottom: 34px ;
margin-left: 34px;
background: #dcdcdc;
}
.card_main{
  background: #dcdcdc;
  height: 100px;
  flex: 1;
}
}

  }
}
</style>